import axios from "axios";
import { serverUrl } from "../nestserver";

export async function uploadToS3(file, folder, setProgress = console.log) {
  // 1. Get pre-signed URL from backend
  const preSignedRes = await axios.get(`${serverUrl}/uploads/pre-signed`, {
    params: {
      fileName: file.name,
      fileType: file.type,
      folder: folder,
    },
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
    },
  });

  const { uploadUrl, key, cdnUrl } = preSignedRes.data;

  // 2. Upload file directly to S3
  await axios.put(uploadUrl, file, {
    headers: {
      "Content-Type": file.type,
    },
    onUploadProgress: (progressEvent) => {
      if (progressEvent.total) {
        setProgress(
          Math.round((progressEvent.loaded * 100) / progressEvent.total),
        );
      }
    },
  });

  // 3. Return object in the format expected by the app
  return {
    id: key.split("/").pop(), // Extracting the filename part as ID for consistency
    files: {
      original: cdnUrl,
      name: file.name,
    },
    metadata: {
      originalname: file.name,
      size: file.size,
      format: file.name.split(".").pop(),
      timestamp: Date.now(),
    },
  };
}

export async function uploadFile(data, folder, setProgress = console.log) {
  return await uploadToS3(data.file, folder, setProgress);
}

export async function uploadDoc(data, folder, setProgress = console.log) {
  return await uploadToS3(data.file, folder, setProgress);
}

export async function uploadMultipleDoc(
  data,
  folder,
  setProgress = console.log,
) {
  if (!data.files || !data.files.length) {
    throw new Error("No files selected for upload.");
  }

  const results = [];
  for (const file of data.files) {
    const result = await uploadToS3(file, folder, (progress) => {
      setProgress(`Uploading ${file.name}: ${progress}%`);
    });
    results.push(result);
  }

  return results;
}
